// extracted by mini-css-extract-plugin
export default {"border-container":"1px solid rgb(221, 224, 230)","container":"styles_container__54YMx","logo":"styles_logo__p7Db5","disclaimer":"styles_disclaimer__b3kov"};